import { controls,grouped } from "../controls";
const calamity_fund_uploads = {
label: "Calamity Fund Uploads",
visitingBranches: 'readonly',
pageLabel: "Calamity Fund Uploads",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Acceptance",uid: "acceptance",fastpath:"acceptances"},
{label: "Transactions",uid: "calamity_fund_transactions",fastpath:"calamity_fund_transactions"}
]},
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Village",star:true}),
...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code",isRequired:true,fastpath: "villages" ,isReadOnly:"edit" ,isReadOnly:true,defaultValue: 'assigned_branch',hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "village_display"}),
...controls.displayText({ tab: "general", label: "Round Figure Difference"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "round_figure_difference",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Actual Sum"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "actual_sum",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "File Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "file_amount",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Total Count",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "total_count",maxlength:200 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Name Column",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "name_column",maxlength:4 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Amount Column",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "amount_column",maxlength:4 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Account Column",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "account_column",maxlength:4 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.checkBox({ tab: "general", label: "Acknowledge",default:false, name: "acknowledge",parents:[{"name": "branch_display", "match": "in", "value": ["khasdkhakue"]}] }),
...controls.displayText({ tab: "acceptance", label: "Acceptance Status",star:false}),
...controls.autoComplete({tab: "acceptance", name: "acceptance.acceptance_status_code", width: "col-sm-2",controlType: "AcceptanceStatus"}),
...controls.displayText({ tab: "acceptance", label: ""}),
...controls.displayText({ tab: "acceptance", label: "Acceptance Remark",star:false,parents:[{"name": "acceptance.acceptance_status_code", "match": "in", "value": ["accept"]}]}),
...controls.text({ tab: "acceptance",  placeHolder: "", name: "acceptance.acceptance_remark",width:"col-sm-4",maxlength:200,parents:[{"name": "acceptance.acceptance_status_code", "match": "in", "value": ["accept"]}],isRequired:true}),
...controls.displayText({ tab: "acceptance", label: "Rejection Remark",star:false,parents:[{"name": "acceptance.acceptance_status_code", "match": "in", "value": ["reject"]}]}),
...controls.text({ tab: "acceptance",  placeHolder: "", name: "acceptance.rejection_remark",width:"col-sm-4",maxlength:200,parents:[{"name": "acceptance.acceptance_status_code", "match": "in", "value": ["reject"]}],isRequired:true}),
...controls.displayText({ tab: "calamity_fund_transactions", label: "Account No",star:false}),
...controls.text({ tab: "calamity_fund_transactions",  placeHolder: "", name: "account_no",maxlength:20,isRequired:true}),
...controls.displayText({ tab: "calamity_fund_transactions", label: ""}),
...controls.displayText({ tab: "calamity_fund_transactions", label: "Ifsc",star:false}),
...controls.text({ tab: "calamity_fund_transactions",  placeHolder: "", name: "ifsc",maxlength:11}),
...controls.displayText({ tab: "calamity_fund_transactions", label: ""}),
...controls.displayText({ tab: "calamity_fund_transactions", label: "Bank Account Code",star:false}),
...controls.text({ tab: "calamity_fund_transactions",  placeHolder: "", name: "bank_account_code",maxlength:30}),
...controls.displayText({ tab: "calamity_fund_transactions", label: ""}),
...controls.displayText({ tab: "calamity_fund_transactions", label: "Full Name",star:false}),
...controls.text({ tab: "calamity_fund_transactions",  placeHolder: "", name: "full_name",width:"col-sm-4",maxlength:500 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "calamity_fund_transactions", label: "Total Amount"}),
...controls.floatOnly({ tab: "calamity_fund_transactions",  placeHolder: "", name: "total_amount",maxlength:18 ,isReadOnly:"edit" ,isReadOnly:true}),
...controls.displayText({ tab: "calamity_fund_transactions", label: ""}),
...controls.displayText({ tab: "calamity_fund_transactions", label: "Name at Bank",star:false}),
...controls.text({ tab: "calamity_fund_transactions",  placeHolder: "", name: "cbs_name",width:"col-sm-4",maxlength:200 ,isReadOnly:"edit" ,isReadOnly:true}),
...controls.displayText({ tab: "calamity_fund_transactions", label: "Mobile",star:false}),
...controls.text({ tab: "calamity_fund_transactions",  placeHolder: "", name: "mobile",maxlength:10}),
...controls.displayText({ tab: "calamity_fund_transactions", label: ""}),
...controls.checkBox({ tab: "calamity_fund_transactions", label: "Confirm Match",default:false, name: "confirm_match" }),
{
widths: "col-sm-12",
tab: "calamity_fund_transactions",
title: "Bank Suggestion Talathi",
subComponents: [
...controls.displayText({ tab: "calamity_fund_transactions", label: "Bank Suggestion",star:false}),
...controls.text({ tab: "calamity_fund_transactions",  placeHolder: "", name: "bank_suggestion_talathi.bank_suggestion",width:"col-sm-4",maxlength:200}),
]},

...controls.displayText({ tab:"calamity_fund_transactions" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"calamity_fund_transactions" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"calamity_fund_transactions",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "calamity_fund_transactions",
  requiredField: ["account_no","ifsc","bank_account_code","full_name","total_amount","cbs_name","mobile","confirm_match",],
required:[],
}, width: "col-sm-2"
}),
...controls.button({
tab:"calamity_fund_transactions",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "calamity_fund_transactions",
  requiredField: ["account_no","ifsc","bank_account_code","full_name","total_amount","cbs_name","mobile","confirm_match",]
}, width: "col-sm-2"
}),
{
  tab:"calamity_fund_transactions",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Account No", field: "account_no"},
    { label: "Ifsc", field: "ifsc"},
    { label: "Bank Account Code", field: "bank_account_code"},
    { label: "Full Name", field: "full_name"},
    { label: "Total Amount", field: "total_amount"},
    { label: "Name at Bank", field: "cbs_name"},
    { label: "Mobile", field: "mobile"},
    { label: "Confirm Match", field: "confirm_match", displaytype: "tick"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "calamity_fund_transactions"
},
]
,history:{
perPage: 10,
reportHeader: "Calamity Fund Uploads",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Village",accessor: "CalamityFundUpload-village-village_display",},
]}};
export default calamity_fund_uploads;